import React from "react";

const Loader = () => {
  return (
    <div className="modal-back" style={{ height: "100%", zIndex: 99990 }}>
      {/* <!-- From Uiverse.io by aryamitra06 -->  */}
      <div className="loader1">
        <span className="bar1"></span>
        <span className="bar1"></span>
        <span className="bar1"></span>
      </div>
    </div>
  );
};

export default Loader;
